import type { RivalInsight } from "../../../shared/presentation/rival-insight.js";
import { insightQuery, insightQueryKeys } from "./insight-navigation.js";

export function rememberInsight(finding: RivalInsight): void {
  const url = new URL(window.location.href);
  for (const [key, value] of new URLSearchParams(insightQuery(finding)))
    url.searchParams.set(key, value);
  window.history.replaceState(window.history.state, "", url);
}

export function clearInsight(): void {
  const url = new URL(window.location.href);
  for (const key of insightQueryKeys) url.searchParams.delete(key);
  window.history.replaceState(window.history.state, "", url);
}
